import React from 'react';
import {useTranslation} from 'react-i18next';
import {Alert} from '@taopix/taopix-design-system';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';

type PicturesIgnoredBySmartDesignNotificationProps = {
  open: boolean;
};

const PicturesIgnoredBySmartDesignNotification = ({
  open,
}: PicturesIgnoredBySmartDesignNotificationProps) => {
  const {t} = useTranslation('assistants');
  const ui = useUiState();

  const closeDialog = () => {
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({
        picturesIgnoredBySmartDesignNotification: DialogStatus.Seen,
      })
    );
  };

  return (
    <Alert
      id={'pictured-ignored-notification'}
      open={open}
      type={'info'}
      showTitle={false}
      message={t('str_MessageSomePicturesMayBeIgnored')}
      onClose={closeDialog}
    />
  );
};

export default PicturesIgnoredBySmartDesignNotification;
